export default {
	pageSize: 100,

	apiRoot: '//nidhoggur.rhi.hi.is/ritaskra'
	//apiRoot: 'https://malfar.arnastofnun.is/d'
}